import { registerBlockType } from '@wordpress/blocks';
import {Save} from "./save";
import {Edit} from "./edit";

registerBlockType('meetravel/carousel', {
        "apiVersion": 2,
        "name": "meetravel/carousel",
        "title": "Carosello",
        "category": "common",
        "icon": "superhero-alt",
        "attributes": {
            "carouselId": {
                type: 'string',
            },
            "terms": {
                type: "object",
                default: {}
            },
            "cardType": {
                "type": "object",
                "default": {
                    termId: 406,
                    name: "experience",
                }
            },
            cards: {
               type: 'array',
                default: []
            },
            styleType: {
              type: 'string',
              default: 'experience'
            },
            "carouselsData": {
                "type": "object",
                "default": {
                    "experiences-carousel": {
                        "id": "#experiences-carousel",
                        "options": {
                            "pagination": false,
                            "type": "loop",
                            "padding": "3rem",
                            "gap": "2rem",
                            "mediaQuery": "min",
                            "breakpoints": {
                                "768": {
                                    "perPage": 3,
                                    "rewind": true,
                                    "autoWidth": true,
                                    "autoHeight": true
                                }
                            }
                        }
                    },
                    "reviews-carousel": {
                        "id": "#reviews-carousel",
                        "options": {
                            "pagination": false,
                            "type": "loop",
                            "gap": "2rem",
                            "padding": "3rem",
                            "mediaQuery": "min",
                            "breakpoints": {
                                "768": {
                                    "perPage": 2,
                                    "rewind": true,
                                    "fixedWidth": "30%",
                                    "autoHeight": true
                                }
                            }
                        }
                    },
                    "traveltypes-carousel": {
                        "id": "#traveltype-carousel",
                        "options": {
                            "pagination": false,
                            "type": "loop",
                            "padding": "3rem",
                            "gap": "2rem",
                            "mediaQuery": "min",
                            "breakpoints": {
                                "768": {
                                    "perPage": 4,
                                    "fixedWidth": "20rem",
                                    "rewind": true
                                }
                            }
                        }
                    }
                }
            }
        },
        "version": "1.0.0",
        "description": "Inserisci il blocco e seleziona il tipo di card che vuoi visualizzare",
        "supports": {
            "html": false
        },
        "edit": Edit,
        "save": Save
    }
);




